import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/whole-sales', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/whole-sales/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/whole-sales', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/whole-sales/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/v1/whole-sales/${id}/delete`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const reprint = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/whole-sales/${id}/print`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = (Options = {}) => {
  return httpClient
    .get('/api/v1/whole-sales/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const promotion = () => {
  return httpClient
    .get('/api/v1/whole-sales/promotions')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const quotation = () => {
  return httpClient
    .get('/api/v1/whole-sales/quotations')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const findQuotation = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/whole-sales/quotations/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const findSaleContract = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/whole-sales/salecontracts/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const salecontract = () => {
  return httpClient
    .get('/api/v1/whole-sales/salecontracts')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const bankProfile = () => {
  return httpClient
    .get('/api/v1/whole-sales/bank-profiles')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const findProductSerial = (productId, Options = {}) => {
  return httpClient
    .get(`/api/v1/whole-sales/serials/${productId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const findSerial = serialNumber => {
  return httpClient
    .get(`/api/v1/whole-sales/find-scan-serials/${serialNumber}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

// Updated to accept Options parameter for stock_out_date
export const exFx = (Options = {}) => {
  return httpClient
    .get('/api/v1/whole-sales/exchange-rates', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const warehouse = () => {
  return httpClient
    .get('/api/v1/whole-sales/warehouses')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/whole-sales/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateMain = (id, data) => {
  return httpClient
    .put(`/api/v1/whole-sales/${id}/update-main-info`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const productBalance = data => {
  return httpClient
    .post(`/api/v1/whole-sales/product-balances`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const paymentMethod = (Option = {}) => {
  return httpClient
    .get('/api/v1/whole-sales/payment-methods', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const viewItem = id => {
  return httpClient
    .get(`/api/v1/whole-sales/${id}/view-items`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExel = (Options = {}) => {
  return httpClient
    .post('/api/v1/whole-sales/export-excels', Options, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const productInventory = data => {
  return httpClient
    .post('/api/v1/whole-sales/product-inventories', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const loanRequest = data => {
  return httpClient
    .post('/api/v1/whole-sales/loan-requests', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNextRefInvoiceNumber = (Options = {}) => {
  return httpClient
    .get('/api/v1/whole-sales/next-ref-invoice-number', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const checkRefInvoiceNumber = data => {
  return httpClient
    .post('/api/v1/whole-sales/check-ref-invoice-number', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export default {
  get,
  find,
  store,
  update,
  destroy,
  product,
  promotion,
  reprint,
  quotation,
  salecontract,
  findQuotation,
  findSaleContract,
  bankProfile,
  findProductSerial,
  findSerial,
  exFx,
  formViewModel,
  updateMain,
  paymentMethod,
  warehouse,
  productBalance, // no remove this if conflic
  viewItem,
  productInventory,
  exportExel,
  loanRequest,
  getNextRefInvoiceNumber,
  checkRefInvoiceNumber
}
